/** Раздвижные: витрина «Прямой» по умолчанию, Standard/Premium — отдельные карточки (tier query). */

export const RAZDVIZHNYE_DEFAULT_SUBTYPE = 'pryamoy';
export const RAZDVIZHNYE_DEFAULT_TIER = 'standard';

export function isRazdvizhnyeBranch(group: {
  branch_slug?: string | null;
  category?: string | null;
} | null | undefined): boolean {
  if (!group) return false;
  const b = (group.branch_slug || '').toLowerCase();
  const c = (group.category || '').toLowerCase();
  return b.includes('razdvizh') || c.includes('раздвиж');
}

export function normalizeCatalogTierSlug(raw: string | null | undefined): string | null {
  const t = (raw || '').trim().toLowerCase();
  if (!t) return null;
  if (t === 'premium' || t.includes('premium') || t === 'премиум' || t === 'luxury') return 'premium';
  if (t === 'standard' || t === 'standart' || t.includes('standard') || t === 'стандарт') return 'standard';
  return t;
}

export function pickRazdvizhnyeLeadGroup<T extends { group_id?: string; name?: string }>(
  candidates: readonly T[],
): T | undefined {
  const pryamoy = candidates.find((g) => {
    const gid = String(g.group_id || '');
    if (!gid.includes('::')) return false;
    const sub = gid.split('::')[1]?.toLowerCase() || '';
    return sub === RAZDVIZHNYE_DEFAULT_SUBTYPE || (g.name || '').toLowerCase() === 'прямой';
  });
  return pryamoy ?? candidates[0];
}

export function productGroupTierQuery(tier: string | null | undefined): string {
  const norm = normalizeCatalogTierSlug(tier);
  return norm ? `&tier=${encodeURIComponent(norm)}` : '';
}

/** Сравнение URL медиа Standard vs Premium (без query, по пути /uploads/). */
export function catalogMediaUrlKey(url: string | null | undefined): string {
  const u = String(url ?? '').trim().split('?')[0];
  const i = u.indexOf('/uploads/');
  if (i >= 0) return u.slice(i).toLowerCase();
  return u.toLowerCase();
}

export function filterMediaNotInUrlSet<T extends { url?: string | null }>(
  items: readonly T[],
  excludeKeys: ReadonlySet<string>,
): T[] {
  if (!excludeKeys.size) return [...items];
  return items.filter((m) => !excludeKeys.has(catalogMediaUrlKey(m.url)));
}

type CatalogSystemListRow = { slug?: string | null };

/** Админ-список систем: не подмешивать Premium в Standard и наоборот. */
export function catalogSystemsForTier<T extends CatalogSystemListRow>(
  list: readonly T[],
  tier: string | null | undefined,
): T[] {
  const tierNorm = normalizeCatalogTierSlug(tier);
  if (!tierNorm) return [...list];
  const scoped = list.filter((x) => {
    const slug = String(x?.slug ?? '').toLowerCase();
    if (tierNorm === 'premium') {
      return slug.includes('premium') || slug.includes('премиум') || slug.includes('luxury');
    }
    if (slug.includes('premium') || slug.includes('премиум') || slug.includes('luxury')) return false;
    return slug.includes('standard') || slug.includes('standart') || slug.includes('стандарт') || !slug.includes('premium');
  });
  if (scoped.length > 0) return scoped;
  if (tierNorm === 'premium') {
    return list.filter((x) => {
      const slug = String(x?.slug ?? '').toLowerCase();
      return slug.includes('premium') || slug.includes('премиум');
    });
  }
  return list.filter((x) => {
    const slug = String(x?.slug ?? '').toLowerCase();
    return !slug.includes('premium') && !slug.includes('премиум') && !slug.includes('luxury');
  });
}
